<i18n>
{
  "ja": {
    "marketingNoteMobile": "登録すると、受け入れ確認がすぐにできます！\nいますぐ登録しよう！",
    "signupForFreeMobile": "無料登録"
  },
  "en": {
    "marketingNoteMobile": "When you signup you can send inquiries to warehouses!",
    "signupForFreeMobile": "Signup Free"
  }
}
</i18n>
<template>
  <section class="marketing-search fixed bottom-0 right-0 left-0 z-10 bg-transparent flex items-center justify-end  md:hidden">
    <div class="flex flex-row items-center bg-white py-2 mr-4 rounded-lg">
      <div class="ml-4">
        <p class="text-left text-xs leading-snug inline-block whitespace-pre-wrap">{{ $t('marketingNoteMobile')}}</p>
      </div>
      <div class="text-center flex-grow self-center">
        <button
          class="inline-block px-4 py-2 md:py-3 rounded-full text-center text-xs md:text-sm md:min-w-32 md:bg-secondary text-secondary md:text-white whitespace-no-wrap"
          @click="openModalDialog"
        >
          <span class="inline-block font-bold">{{$t('signupForFreeMobile')}}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.marketing-search {
  bottom: 50px;
  transform: translateY(50%);
  > div {
    @media (min-width: theme('screens.md')) {
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
      max-height: 80px;
    }
    @media (max-width: 767px) {
      background-color: theme('colors.header');
      color: white;
      box-shadow: 1px 2px 5px 0 rgba(83, 83, 83, 0.5);
      margin-left: 96px;
    }
  }
}
.underline-color-orange {
  text-decoration-color: theme('colors.orange');
}
</style>

<script>
import modalMixin from '@/components/mixins/modalHandler';

export default {
  mixins: [ modalMixin ]
}
</script>